<template>
	<div id='auxiliaryBalance'>
		<div class='public-content'>
			<el-form inline :model="form" class='clearfix'>
				<el-form-item label="会计期间：">
					<accounting-period @defaultTime='defaultTime'></accounting-period>
				</el-form-item>
				<el-form-item label="科目名称">
					<el-select v-model="form.subjectId" placeholder="请选择" size='small' filterable clearable>
					    <el-option
					      v-for="item in subjectList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				<el-form-item label="辅助核算类别">
					<el-select v-model="form.auxiliaryAccountingId" placeholder="请选择" size='small' clearable filterable>
					    <el-option
					      v-for="item in allAccountingList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				<el-form-item label="辅助核算名称">
					<el-select v-model="form.auxiliaryAccContentId" placeholder="请选择" size='small' clearable filterable>
					    <el-option
					      v-for="item in auxiliaryList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				<el-form-item>
					<el-button size='small' type='primary' @click='getTableData'>搜索</el-button>
				</el-form-item>
				<div class='fr'>
					<el-button v-for='item in buttonList' :key='item.id' size='small'
					style='margin: 5px 0px 0 20px' @click='handleButtonClick(item.name)'>
						{{item.name}}
					</el-button>
				</div>
			</el-form>
			<public-table  :table="tableData" >
				<template slot='auxiliaryAccContentName' slot-scope='props'>
					<el-button type='text' @click='handleClickJump(props.scope.row)'>{{props.scope.row.auxiliaryAccContentName}}</el-button>
				</template>
			</public-table>
		</div>

    <!-- 仅包含打印封面的弹框 -->
    <PrintCover :isShow="showPrintCover" @close="showPrintCover = false" @print="printHandler($event)" />
	</div>
</template>

<script>

	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
  import PrintCover from "./com/printCover.vue"
	export default {
		components:{
			publicTable,
			accountingPeriod,
      PrintCover
		},
		data() {
			return {
				options:[],
				subjectList:[],     // 科目
				auxiliaryList:[], // 辅助核算名称
				allAccountingList:[],
				form:{
					subjectId:"",
					auxiliaryAccountingId:"",
					start:"",
					end:"",
					auxiliaryAccContentId:"",
				},
        showPrintCover:false,
        printParam:{},
				tableData: {
					border: true, // 是否带有纵向边框
					stripe: true, // 是否带有斑马纹
					loading: false, // 是否显示加载动画
					hasSelect: false, // 是否显示多选
					hasOperation: false, // 是否有操作功能
					hasContextmenu: false, // 是否有右键功能
					hasShowSummary: false, // 是否显示合计行
					hasShowPagination: false, // 是否显示分页
					config: [ {
						label: '科目编码/名称',
						value: 'subjectName',
						show: 'normal'
					}, {
						label: '辅助核算类别',
						value: 'auxiliaryAccountingName',
						show: 'normal'
					}, {
						label: '辅助核算编码/名称',
						value: 'auxiliaryAccContentName',
						show: 'template'
					}, {
						label: '期初余额',
						value: 'initial',
						show: 'normal',
						showChild: true,
						children: [{
							label: '借方数量',
							value: 'initialDebitAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '借方金额',
							value: 'balanceDebit',
							show: 'normal',
							formatter:this.formatter
						}, {
							label: '贷方数量',
							value: 'initialCreditorAmount',
							show: 'normal',
							isShow: true,
							sign: true,
						}, {
							label: '贷方金额',
							value: 'balanceCreditor',
							show: 'normal',
							formatter:this.formatter
						}]
					}, {
						label: '本期发生额',
						value: 'currentPeriod',
						show: 'normal',
						showChild: true,
						children: [{
							label: '借方数量',
							value: 'monDebitAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '借方金额',
							value: 'occurrencePeriodDebit',
							show: 'normal',
							formatter:this.formatter
						}, {
							label: '贷方数量',
							value: 'monCreditorAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '贷方金额',
							value: 'occurrencePeriodCreditor',
							show: 'normal',
							formatter:this.formatter
						}]
					}, {
						label: '本年累计发生额',
						value: 'currentYear',
						show: 'normal',
						showChild: true,
						children: [{
							label: '借方数量',
							value: 'yearDebitAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '借方金额',
							value: 'occurrenceYearDebit',
							show: 'normal',
							formatter:this.formatter
						}, {
							label: '贷方数量',
							value: 'yearCreditorAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '贷方金额',
							value: 'occurrenceYearCreditor',
							show: 'normal',
							formatter:this.formatter
						}]
					}, {
						label: '期末余额',
						value: 'terminal',
						show: 'normal',
						showChild: true,
						children: [{
							label: '借方数量',
							value: 'monEndDebitAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '借方金额',
							value: 'endBalanceDebit',
							show: 'normal',
							formatter:this.formatter
						}, {
							label: '贷方数量',
							value: 'monEndCreditorAmount',
							show: 'normal',
							isShow: true,
							sign: true
						}, {
							label: '贷方金额',
							value: 'endBalanceCreditor',
							show: 'normal',
							formatter:this.formatter
						}]
					}],
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
				firstGet:true,
				firstGets:true,
				isFirstActive: false,
				buttonList:[],
			}
		},
		computed: {
			getClickCache() {
				return this.$store.state.loadstatus.isClickCache;
			},
		},
		created() {
			this.getButtonAuthorize();
		},
		activated() {
			if(this.getClickCache && this.isFirstActive) {
				this.firstGets = true;
				this.form.auxiliaryAccContentId = "";
				this.form.auxiliaryAccountingId = "";

				this.getSubjectAuxiliary();
				this.findAllOject();
			}
			this.isFirstActive = true;
		},
		methods: {
			// 点击辅助核算编码
			handleClickJump(row) {
				let params = {
					subjectId:row.subjectId,  // 科目id
					auxId:row.auxId,  // 辅助核算类别ID
					accontentId:row.accontentId // 辅助核算详细ID
				}
				this.$router.push({path:"./auxiliaryDetailed",query:params})
			},
			// 格式化
			formatter(row, column, cellValue, index) {
				if(!cellValue) {
					return "";
				}
				return currencys(cellValue);
			},
			// 打印&&导出
			handleButtonClick(name) {
				let params = JSON.parse(JSON.stringify(this.form));
				params.start = this.$util.formatDate.format(params.start , 'yyyyMM');
				params.end = this.$util.formatDate.format(params.end , 'yyyyMM');
				params = Object.assign(params, {
						cid: sessionStorage.cid,
						token: sessionStorage.token,
					})
				if(name === "打印") {
          this.printParam = params
          this.showPrintCover = true
				}else {
					const routers =this.$router.resolve({
			          path: '/export/balanceSheet',
			          query: params
			        })
			         window.location.href = this.$rootUrl + routers.href;
				}
			},
      printHandler(form){
        const printParam = JSON.parse(JSON.stringify(this.printParam))
        printParam.isCover = form.isCover
        const router = this.$router.resolve({
					path: '/auxiliary/balanceSheet',
					query: printParam
				})

        this.showPrintCover = false
				window.open(this.$rootUrl + router.href, '_blank')
      },
			// 获取打印导出导入按钮权限
		      getButtonAuthorize() {
		        const _ = this;
		        let params={
		          permissions:'ac:supplementary:print,ac:supplementary:export'
		        }
		         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
		            if(res && res.data.code == 1) {
		              _.buttonList = res.data.data;
		            }
		         })
		      },
			// 会计期间传过来的数据
			defaultTime(data) {
				this.form = Object.assign(this.form,{
					start: data.yearPeriodsStart,
					end:  data.yearPeriodsEnd,
				})

				this.getSubjectAuxiliary();
				if(this.firstGet) {
					this.findAllOject();
					this.firstGet = false;

				}
			},
			getTableData(){
				let data = JSON.parse(JSON.stringify(this.form));
				data.start = this.$util.formatDate.format(data.start , 'yyyyMM');
				data.end = this.$util.formatDate.format(data.end , 'yyyyMM');
				this.$http.post('subjectAuxiliary/getBalanceListByAuxiliaryContent',data).then((res)=>{
					if(res && res.data.code == '1'){
						this.tableData.data = res.data.data;
					}
				})
			},
			//查询辅助类别
			findAllOject(){
				const _=this;
				let datas = {
				}
				_.$http.post('auxiliaryAccounting/allAccounting',datas).then((res)=>{
					if(res && res.data.code == '1'){
						this.allAccountingList = res.data.data;

					}
				})
			},
			// 获取科目辅助核算
			getSubjectAuxiliary(){
				let params={
					start:this.$util.formatDate.format(this.form.start , 'yyyyMM'),
					end:this.$util.formatDate.format(this.form.end , 'yyyyMM'),
				}

				this.$http.post('subjectAuxiliary/findAuxiliaryHappenData',params).then(res=>{
					if(res&&res.data.code==1) {
						this.subjectList = res.data.data.subjectAuxiliary.map(i=>{
							i.name=i.code+" "+i.name;

							return i;
						});
						//this.form.subjectId=res.data.data.subjectAuxiliary.length?res.data.data.subjectAuxiliary[0].id:"";

						this.auxiliaryList = res.data.data.auxiliaryAccContent.map(i=>{
							i.name=i.code+" "+i.name;

							return i;
						});
						// this.form.auxiliaryAccContentId=res.data.data.auxiliaryAccContent.length?res.data.data.auxiliaryAccContent[0].id:"";
						if(this.firstGets) {
							this.getTableData();
							this.firstGets = false;
						}

					}
				})

			},
		},

	}
</script>

<style lang="less" >
</style>



// WEBPACK FOOTER //
// src/pages/accountBook/auxiliaryBalance.vue